module.exports = __webpack_public_path__ + "img/place.fc69fb27.png";